import { Flex } from '@mantine/core'

import { AssetsDebtChart } from '@/components/@Shared/AssetsDebtChart/AssetsDebtChart'
import { AssetsValueChart } from '@/components/@Shared/AssetsValueChart/AssetsValueChart'
import { DebtValueChart } from '@/components/@Shared/DebtValueChart/DebtValueChart'
import { TransactionSyncNotice } from '@/components/@Shared/TransactionSyncNotice/TransactionSyncNotice'
import { Insights } from '@/components/Insights/Insights'

import { page as InsightPage } from '@/__generated__/requests'

import classes from './NetWorthShell.module.css'

export function NetWorthShell() {
  return (
    <>
      <TransactionSyncNotice mb={24} />

      <Insights page={InsightPage.NET_WORTH} staticMargin />

      <AssetsDebtChart />

      <Flex className={classes.donutContainer}>
        <AssetsValueChart extended />

        <DebtValueChart extended />
      </Flex>
    </>
  )
}
